// FONTE UNICA di configurazione dei metodi di Arcana (regola strutturale permanente).
// Ogni nuovo metodo si aggiunge SOLO in questa tabella: da qui derivano automaticamente
// il menu «Oracoli e carte» (nav desktop e mobile), il catalogo «Scopri altro»,
// il pannello admin dei metodi e l'elenco dei metodi preferibili (cuore).
// Non inserire metodi non ancora disponibili: ciò che non è qui non compare da nessuna parte.
//
// Campi:
//   to     → percorso della pagina del metodo
//   menu   → etichetta nel menu «Oracoli e carte» (se assente, non compare nel menu)
//   heart  → il metodo può essere segnato «del cuore»
//   deck   → chiave del mazzo: abilita la scheda di gestione nel pannello admin
//   title  → presenza nel catalogo «Scopri altro» (con image e ordine cat)
//   cat    → posizione nel catalogo (rispetta l'ordine esistente)
const METHODS_CONFIG = [
  { to: "/lettura", menu: "Vera Sibilla", heart: true },
  { to: "/tarocchi", menu: "Tarocchi", heart: true, deck: "tarocchi", title: "Tarocchi", image: "/methods/tarocchi.jpg", cat: 1 },
  { to: "/napoletane", menu: "Napoletane", heart: true, deck: "napoletane", title: "Napoletane", image: "/methods/napoletane.jpg", cat: 2 },
  { to: "/stesa26", menu: "Stesa 26", heart: true, deck: "stesa26", title: "Stesa 26", image: "/methods/stesa26.jpg", cat: 3 },
  { to: "/piacentine", menu: "Piacentine", heart: true, deck: "piacentine", title: "Piacentine", image: "/methods/piacentine.jpg", cat: 4 },
  { to: "/baraja", menu: "Baraja Española", heart: true, deck: "baraja", title: "Baraja Española", image: "/methods/baraja.jpg", cat: 5 },
  { to: "/oracolo", menu: "L'Oracolo del Destino", heart: true, deck: "oracolo", title: "L'Oracolo del Destino", image: "/methods/oracolo.jpg", cat: 6 },
  { to: "/geomanzia", menu: "Geomanzia", heart: true },
  { to: "/rune", menu: "Rune", heart: true, deck: "rune", title: "Rune", image: "/methods/rune.jpg", cat: 7 },
  { to: "/iching", menu: "I Ching", heart: true },
  { to: "/numerologia", menu: "Numerologia", heart: true, title: "Numerologia", image: "/methods/numerologia.jpg", cat: 9 },
  { to: "/cielo", menu: "Il Cielo", heart: true, title: "Il mio cielo", image: "/methods/oroscopo.jpg", cat: 8 },
  { to: "/oroscopo", menu: "Oroscopo settimanale" },
  // Voce del catalogo che non è un metodo di lettura: lo storico personale.
  { to: "/letture", title: "Le mie letture", image: "/methods/letture.jpg", cat: 10 },
];

// Menu «Oracoli e carte» (Layout, desktop e mobile), nell'ordine della tabella.
export const ORACOLI_MENU = METHODS_CONFIG
  .filter((m) => m.menu)
  .map((m) => ({ to: m.to, label: m.menu }));

// Metodi che l'utente può segnare come «del cuore» (cuore sulle schede).
export const METODI_PREFERIBILI = METHODS_CONFIG
  .filter((m) => m.heart)
  .map((m) => m.to.slice(1));

// Catalogo «Scopri altro» e pannello admin dei metodi (le voci con `deck`
// generano automaticamente la scheda di gestione del mazzo), ordine `cat`.
export const ALTRO_TOOLS = METHODS_CONFIG
  .filter((m) => m.title)
  .sort((a, b) => a.cat - b.cat)
  .map((m) => ({
    to: m.to,
    testid: `altro-${m.to.slice(1)}`,
    image: m.image,
    title: m.title,
    ...(m.deck ? { deck: m.deck } : {}),
  }));
